<template>
    <div>
        <button class="btn btn-outline-secondary" @click="upload()" :disabled="$store.state.loading">
            <i class="fa-solid fa-file-import mr-2" v-if="!$store.state.loading"></i> 
            <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                <span class="sr-only">Loading...</span>
            </div>

            Importar XML
        </button>

        <!-- Modal Importação de Resultados -->
        <div class="modal fade" id="smartRetornoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Requisições</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="retorno && retorno.retornos">
                            Foram processadas {{ retorno.retornos.length }} requisições.
                        </div>

                        <table class="table table-hover" v-if="retorno">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Origem</th>
                                    <th>Exames</th>
                                    <th>Amostras</th>
                                    <th>Logs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(retorno, irx) in retorno.retornos" :key="irx" :class="get_dado(retorno, 'retorno.retorno.logs', []).length ? 'table-warning' : ''">
                                    <td>
                                        <a href="#" @click.prevent="abrir_atendimento(get_dado(retorno, 'retorno.retorno.id_klingo'))" class="card-link" v-if="!portal">
                                            #{{ get_dado(retorno, 'retorno.retorno.id_klingo') }}
                                        </a>
                                        <span v-else>
                                            #{{ get_dado(retorno, 'retorno.retorno.id_klingo') }}
                                        </span>
                                    </td>
                                    <td>
                                        {{ get_dado(retorno, 'retorno.retorno.id_origem') }}
                                    </td>
                                    <td>
                                        <span class="badge badge-primary mr-1" v-for="(exame, iex) in get_dado(retorno, 'retorno.retorno.exames', [])" :key="iex">
                                            {{ exame.codigo }}
                                        </span>
                                    </td>
                                    <td>
                                        <div v-for="(amostra, iex) in get_dado(retorno, 'retorno.retorno.amostras', [])" :key="iex">
                                            {{ amostra.codigoamostra }} / {{ amostra.titulo }}
                                        </div>
                                    </td>
                                    <td>
                                        <ul class="mb-0">
                                            <li v-for="(log, ilog) in get_dado(retorno, 'retorno.retorno.logs', [])" :key="ilog">
                                                {{ log }}
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <pre v-if="false">{{ retorno }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';

export default {
    data() {
        return { 
            retorno: null, 
        };
    },

    props: [
        'id_apoiado', 
        'portal', 
    ],

    methods: { 
        fechar_modal() { 
            $('#smartRetornoModal').modal('hide');
        },

        abrir_atendimento(id_atendimento) {
            $('.modal').modal('hide');
            this.$util.abrir_atendimento(this, id_atendimento);
        },
        
        get_dado(item, campo) { 
            return _.get(item, campo);
        },

        upload() {
            var downloadAnchorNode = document.createElement('input');
            downloadAnchorNode.setAttribute("type", "file");
            downloadAnchorNode.setAttribute("class", "d-none");
            downloadAnchorNode.setAttribute("accept", ".xml");
            downloadAnchorNode.onchange = () => { this.posUpload(downloadAnchorNode); };
            document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
        },

        posUpload(el) {
            this.retorno = null; 
            var file = el.files[0];

            if (file) {

                // console.log('Arquivo', file);

                var reader = new FileReader();

                // reader.readAsText(file, "UTF-8");

                reader.readAsText(file, "ISO-8859-1");

                reader.onload = (evt) => {
                    
                    let xml = evt.target.result; 

                    console.log('XML', xml);

                    this.$util.atualizar(this, {
                        service: 'amostras',
                        func: 'importar_xml_smart',
                        redir_api: true, 
                        dados: {
                            id_apoiado: this.id_apoiado, 
                            xml: xml,
                        },
                        toast: true, 
                        callback: res => {
                            console.log('res', res);

                            this.retorno = res;
                            $('#smartRetornoModal').modal('show');

                            if ( this.portal && res && res.retornos && res.retornos.length ) { 
                                let lista = res.retornos.map(r => _.get(r, 'retorno.retorno.id_klingo'))
                                    .filter(item => item);

                                this.$emit('buscar', lista);
                            }
                        }
                    });
                }

                reader.onerror = function () {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Falha lendo arquivo.",
                        life: 3000
                    });
                }

            } else {

                console.log('arquivo não encontrado.');

            }
        },
    }
}
</script>
